// @flow

import Pagination from '../components/Pagination';
import Notifications from '../constants/Notifications';

export default class FilterPagination extends Pagination {
  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.addListener(Notifications.FILTERED, this.handleFiltered);
  }

  /**
   * Executes when the user filters
   */
  handleFiltered({ data }: Object): void {
    if (Object.prototype.hasOwnProperty.call(data, 'paginationView')) {
      super.rebuildComponent(data.paginationView);
    }
  }
}
